<template>
    <ui-modal :class="css.container" ref="modal" spacing="144px 168px 68px" :close="false" :width="1104" :height="550" :close-on-click="false">
        <div :class="css.status">
            <div :class="[css.module, status.verify && css[status.verify]]">
                <ui-icon :class="css.image" :name="verify_status" />
                <div :class="css.content">{{ $t("CheckingData") }}</div>
            </div>

            <img :class="css.arrow" src="https://rdgta.cdn.cyagen.com/rddc/pictures/4ecbce25-4f25-4394-8d43-40989584d89f.webp" alt="箭头" />

            <div :class="[css.module, status.forecast && css[status.forecast]]">
                <ui-icon :class="css.image" :name="forecast_status" />
                <div :class="css.content">{{ $t("ProcessingData") }}</div>
            </div>

            <img :class="css.arrow" src="https://rdgta.cdn.cyagen.com/rddc/pictures/e32728a0-5a21-44a1-bf83-7d95add8fd26.webp" alt="箭头" />

            <div :class="[css.module, status.forecast == 'success' && status.verify == 'success' && css.success]">
                <ui-icon :class="css.image" name="success" />
                <div :class="css.content">{{ $t("Prediction") }}</div>
            </div>
        </div>

        <div :class="[css.footer, (status.verify == 'error' || status.forecast == 'error') && css.error]">
            <span v-if="status.verify != 'success' || status.forecast != 'success'" class="color-1 font-variable">{{ message }}</span>
            <template v-else>
                <ui-button size="middle" @click="methods.next">{{ $t("ViewReport") }}</ui-button>
            </template>
        </div>
    </ui-modal>
</template>

<script lang="ts" setup>
//* 组件库
import { UiButton, UiModal, UiIcon } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";

//* 组合函数
const { refs, nodes, methods, variable, computeds } = useComposable();
const { status } = refs;
const { modal } = nodes;
const { open } = methods;
const { message, verify_status, forecast_status } = computeds;

//* 组件卸载时移除定时器
onBeforeUnmount(() => clearTimeout(variable.timer));
//* 组件属性导出
defineExpose({ open });
</script>
